export const PREFERENCE_KEYS = <Record<string, string>>{
  ACTION_PRIORITY_SCALE: 'action.priority_scale',
  ACTION_REVIEW: 'action.review',
  AUTH_MFA_DEFAULT: 'auth.mfa_default',
  AUTH_USE_SAML: 'auth.use_saml',
  DASHBOARD_HOME: 'dashboard.home',
  EXEMPTION_CRITICALITY_SCALE: 'exemption.criticality_scale',
  EXEMPTION_DEFAULT_REGISTER: 'exemption.default_register',
  EXTERNAL_ADR: 'external.adr',
  FORCE_METRIC_ENTRY_RUNTASK: 'force_metric_entry_runtask',
  GAP_CRITICALITY_SCALE: 'gap.criticality_scale',
  INCIDENT_AVAILABILITY_SCALE: 'incident.availability_scale',
  INCIDENT_CONFIDENTIALITY_SCALE: 'incident.confidentiality_scale',
  INCIDENT_CRITICAL_VALUE: 'incident.critical_value',
  INCIDENT_IMPACT_MODE: 'incident.impact_mode',
  INCIDENT_IMPACT_SCALE: 'incident.impact_scale',
  INCIDENT_INTEGRITY_SCALE: 'incident.integrity_scale',
  INCIDENT_PROOF_SCALE: 'incident.proof_scale',
  INDICATOR_TRIM_OVERPERF: 'indicator.trim_overperf',
  INTERNAL_SCALE: 'internal_scale',
  INTERNAL_TARGET: 'internal_target',
  INVITE_DEFAULT_TEXT_EN: 'invite.default_text.en',
  INVITE_DEFAULT_TEXT_FR: 'invite.default_text.fr',
  ISP_ACTION_DEFAULT_REGISTER: 'isp_action_default_register',
  JIRA_API_KEY: 'jira.api_key',
  JIRA_DOMAIN: 'jira.domain',
  JIRA_PREFIX: 'jira.prefix',
  JIRA_USER: 'jira.user',
  LOGO_MAIN: 'logo.main',
  MEASURE_COVERAGE_EFFICIENCY: 'measure.coverage_efficiency',
  MEASURE_DEFAULT_PERFORMANCE: 'measure.default_performance',
  MEASURE_TASK_TIMERANGE: 'measure.task_timerange',
  METRIC_ENTRY_MONTHLY_TOLERANCE_DAYS: 'metric_entry.monthly_tolerance_days',
  METRIC_ENTRY_WEEKLY_TOLERANCE_DAYS: 'metric_entry.weekly_tolerance_days',
  PASSWORD_COMPLEXITY: 'password.complexity',
  PASSWORD_HISTORY: 'password.history',
  PASSWORD_MAX_AGE: 'password.max_age',
  PASSWORD_MIN_AGE: 'password.min_age',
  PASSWORD_MIN_SIZE: 'password.min_size',
  PASSWORD_REMINDER: 'password.reminder',
  PERFORMANCE_SCALE: 'performance_scale',
  PERIMETER_AVAILABILITY_SCALE: 'perimeter.availability_scale',
  PERIMETER_CONFIDENTIALITY_SCALE: 'perimeter.confidentiality_scale',
  PERIMETER_CRITICALITY_MODE: 'perimeter.criticality_mode',
  PERIMETER_CRITICALITY_SCALE: 'perimeter.criticality_scale',
  PERIMETER_INTEGRITY_SCALE: 'perimeter.integrity_scale',
  PERIMETER_PROOF_SCALE: 'perimeter.proof_scale',
  PROJECT_EVAL_SCALE: 'project.eval_scale',
  RISK_ANALYSIS_CUSTOM_CRITERIA: 'risk.analysis.custom_criteria',
  RISK_DEFAULT_MEASURE_PERFORMANCE: 'risk.default_measure_performance',
  RISK_HIGH_THRESHOLD: 'risk.high_threshold',
  RISK_IMPACT_SCALE: 'risk.impact_scale',
  RISK_LEVEL_SCALE: 'risk.level_scale',
  RISK_PROBABILITY_SCALE: 'risk.probability_scale',
  UI_CURSOR_GRANULARITY: 'ui.cursor_granularity',
  WARN_GROUPING_TRUSTEDSCORE: 'warn.grouping.trustedscore',
  WARN_MEASURE_PERFORMANCE: 'warn.measure.performance',
  WARN_PERIMETER_RISK: 'warn.perimeter.risk',
  WARN_PERIMETER_TRUSTEDSCORE: 'warn.perimeter.trustedscore',
  WARN_RISK_TREATMENT: 'warn.risk.treatment',
  WARN_RUNTASK_COMPLETION: 'warn.runtask.completion',
  WEATHER_SCALE: 'weather_scale',
}
